module.exports = __webpack_public_path__ + "img/bsc_04.324a8c69.png";